import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import ReportingDataService from "../../services/reporting-data-service/ReportingDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IReportTaskSummaryDTO } from "../../services/reporting-data-service/ReportScheduleModels";

export type UseReportTaskListQueryParameters = {
    organizationID: number,
    groupID: number;
    myReports: boolean;
} & BaseUseQueryParameters<IReportTaskSummaryDTO[]>;

export function useReportTaskList({
    organizationID,
    groupID,
    myReports,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseReportTaskListQueryParameters) {
    return useQuery<IReportTaskSummaryDTO[], RestError>(
        keys.taskList(
            organizationID,
            groupID
        ),
        ({ signal }) => {
            return ReportingDataService.getReportTaskList(
                organizationID,
                groupID,
                myReports,
                signal
            );
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
            staleTime: 0
        }
    );
}
